import { IDCancellationReason } from 'cancellations/components/shared/accordion-change-control-data/cancellation-reason';
import { ChangeControlDataForm } from 'cancellations/view-models/cancellation-due-death';
import { DateTime } from 'luxon';
import { ModelEventoDTO } from 'shell/models/act-category-list';

export const transformChangeControlDataForm = (
  modelEventoDTO: ModelEventoDTO
): ChangeControlDataForm => {
  return {
    effectiveDate: modelEventoDTO.dataformazione
      ? DateTime.fromISO(modelEventoDTO.dataformazione)
      : modelEventoDTO.datiDiMorte?.dataMorte
      ? DateTime.fromISO(modelEventoDTO.datiDiMorte.dataMorte)
      : modelEventoDTO.datiDiMorte?.dataPresuntaMorteDa
      ? DateTime.fromISO(modelEventoDTO.datiDiMorte?.dataPresuntaMorteDa)
      : null,
    cancellationReason: Boolean(modelEventoDTO.datiDiMorte?.dataMorte)
      ? IDCancellationReason.Accertata
      : IDCancellationReason.Presunta,
  };
};
